import * as React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

type PaywallNoticeProps = {
  feature?: string;
  ctaLabel?: string;
  className?: string;
};

export function PaywallNotice({
  feature,
  ctaLabel = 'Upgrade',
  className = '',
}: PaywallNoticeProps) {
  return (
    <div
      data-testid="paywall-notice"
      className={cn('rounded-xl border border-muted p-4 bg-muted/30', className)}
    >
      <div className="text-sm font-medium">Premium feature</div>
      <div className="text-sm text-muted-foreground mt-1">
        {feature
          ? `${feature} is available with No Doubles Premium.`
          : 'This feature will be available with No Doubles Premium.'}
      </div>
      <div className="mt-3">
        <Button
          variant="outline"
          size="sm"
          disabled
          data-testid="paywall-cta"
          title="Billing not enabled yet"
        >
          {ctaLabel}
        </Button>
      </div>
      <div className="mt-2 text-xs text-muted-foreground">
        Payments are not enabled yet.
      </div>
    </div>
  );
}

export default PaywallNotice;
